"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = __importDefault(require("./styles"));
var Dropdown = function (_a) {
    var isHidden = _a.isHidden, children = _a.children, className = _a.className, parentRef = _a.parentRef;
    if (isHidden)
        return null;
    var selectContainer = parentRef.current.getBoundingClientRect();
    var dropdownPosition = {
        top: selectContainer.top + selectContainer.height + 8,
        left: selectContainer.left
    };
    return react_1.default.createElement(styles_1.default, { className: className || '', style: dropdownPosition }, children);
};
exports.default = Dropdown;
//# sourceMappingURL=index.js.map